export default __webpack_public_path__ + "static/media/brookshire-smm.2a956972.pdf";